import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import FanxoStar from "../../Assets/Images/FanxoStar.svg";
import * as S from "./styles";

const SplashScreen: React.FC = () => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <S.SplashScreenWrapper aria-label="Fanxo loading">
      <S.Glow />
      <S.LogoFrame
        as={motion.div}
        initial={
          prefersReducedMotion
            ? { opacity: 1, scale: 1, rotate: 0 }
            : { opacity: 0, scale: 0.42, rotate: -55 }
        }
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={
          prefersReducedMotion
            ? { duration: 0 }
            : {
                duration: 1.78,
                ease: [0.65, 0, 0.35, 1],
              }
        }
      >
        <S.Logo src={FanxoStar} alt="Fanxo" draggable={false} />
      </S.LogoFrame>
    </S.SplashScreenWrapper>
  );
};

export default SplashScreen;
